export const PlayIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <circle cx="16" cy="16" r="16" fill="#6C6C89" fillOpacity="0.08"/>
    <path d="M20.5 14.634C21.1667 15.0189 21.1667 15.9811 20.5 16.366L13.75 20.2631C13.0833 20.648 12.25 20.1669 12.25 19.3971L12.25 11.6029C12.25 10.8331 13.0833 10.352 13.75 10.7369L20.5 14.634Z" fill="black"/>
  </svg>
);
